import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import { refSagaActions } from "../../Administration/ReferenceInfoManagement";
// import { agencySagaActions } from "../../Administration/AgencyManagement";
import { serviceSagaActions } from "../../Administration/ServiceManagement";
import { serviceItemSagaActions } from "../../Administration/ServiceItemManagement";
import { provinceSagaActions } from "../../Administration/ProvinceInfoManagement";

import { Formik } from "formik";
import * as Yup from "yup";
import { format } from "date-fns";
import { Button, Form, Col, Card, Collapse } from "react-bootstrap";
import { ClipboardData, CaretDownFill, CaretUpFill, Files, Calendar4Week } from "react-bootstrap-icons"
import ReactDatePicker from "react-datepicker";

import styles from "../css/ReportSearchForm.module.css";
import "react-datepicker/dist/react-datepicker.css";

const presentDate = new Date();
const formatPresentDate = format(presentDate, "dd-MMMM-yyyy");

//search form schema definition
const reportSearchFormSchema = Yup.object().shape({
  prioritySearch: Yup.object({}),
  reportName: Yup.string().required("*Select report type"),
  dept: Yup.string(),
  province: Yup.string(),
  interval: Yup.string().required("*Select time interval"),
  fromDate: Yup.date()
    .max(presentDate, `Date must be earlier than the ${formatPresentDate}`),
  toDate: Yup.date()
    .min(Yup.ref('fromDate'), "*'Date To' must be after the 'Date From'")
    .max(presentDate, `*Date must be earlier than the ${formatPresentDate}`),
  serviceType: Yup.string(),
  serviceItem: Yup.string(),
}, ['fromDate', 'toDate']);

export function ReportSearchForm(props) {
  const dispatch = useDispatch();
  const searchFormRef = useRef();

  const { reference, /*agency,*/ services, auth, serviceItem, province } = useSelector((state) => state);

  const { allReferences, referenceKinds } = reference;
  // const { agencies } = agency;
  const { serviceTypes } = services;
  const { serviceItems } = serviceItem;
  const { provinces } = province;
  const { user } = auth;

  const provAgencyId = user.prov_agency_id;
  let agencyId = services.serviceTypes.length > 0 ? services.serviceTypes[0].department_id : "";

  const queryParamsInitialState = {
    fromDate: "",
    toDate: "",
    dept: agencyId,
    provAgencyId: provAgencyId,
    serviceType: "",
    serviceItem: "",
    reportName: "",
    province: "",
    interval: ""
  };

  const [ receiptStatuses, setReceiptStatuses ] = useState([]);
  const [ reportTypes, setReportTypes ] = useState([]);
  const [ timeInterval, setTimeInterval ] = useState([]);
  const [ customIntervalId, setCustomIntervalId ] = useState();
  const [ selectedInterval, setSelectedInterval ] = useState();
  const [showSearch, setShowSearch] = useState(true);
  const [serviceItemList, setServiceItemList] = useState([]);
  

  useEffect(() => {

    dispatch(refSagaActions.fetchAllReferences());
    dispatch(refSagaActions.fetchReferenceKinds());
    // dispatch(agencySagaActions.fetchAgencies());
    dispatch(serviceSagaActions.fetchServices(provAgencyId));
    dispatch(serviceItemSagaActions.fetchServiceItems(provAgencyId));
    dispatch(provinceSagaActions.fetchProvinces({id: provAgencyId.toString()}));
  }, [dispatch, provAgencyId]);

  useEffect(() => {
    if(referenceKinds.length > 1){
      let receiptStatusKind = referenceKinds.find((kind) => (kind.code === "RECEIPT_STATUS"));
      let recStats = allReferences.filter((ref) => (ref.kindId === receiptStatusKind.id && ref.description !== "Invalid"));
      setReceiptStatuses(recStats);
    
      let reportKind = referenceKinds.find((kind) => (kind.code === "REPORT_TYPES"));
      let reportTypes = allReferences.filter((ref) => (ref.kindId === reportKind.id));
      setReportTypes(reportTypes);

      let tiKind = referenceKinds.find((kind) => (kind.code === "TIME_INTERVAL"));
      let intervals = allReferences.filter((ref) => (ref.kindId === tiKind.id));
      intervals.forEach(int => {
        if(int.code === "SPECIFIC"){
          setCustomIntervalId(int.id);
        }
      });
      setTimeInterval(intervals);
    }
  }, [referenceKinds, allReferences]);

  const filterServiceItems = (serviceTypeId) => {
    let serviceItemList = serviceItems.filter((item) => (item.service_id === Number(serviceTypeId)));
    setServiceItemList(serviceItemList);
  };


  const handleSearchReportReset = () => {
    searchFormRef.current.reset();
    let today = format(presentDate, "dd/MM/yyyy");
    props.onHandleSearchReport({
      p_fromDate: today,
      p_toDate: today
    });
  };


  const calcFromToDates = (intId) => {
    let interval = allReferences.find((ref) => (ref.id === Number(intId)));
    
    let today = new Date();
    let timeInt = {
      description: interval.description,
      from: "",
      to: format(today, "dd/MM/yyyy")
    };
    if(interval.description === "Daily"){

      timeInt.from = format(today, "dd/MM/yyyy");
      timeInt.to = "";

    } else if (interval.description === "Weekly"){

      timeInt.from = format(new Date(new Date(today).setDate(today.getDate() - 7)), "dd/MM/yyyy");

    } else if (interval.description === "Monthly"){

      timeInt.from = format(new Date(new Date(today).setMonth(today.getMonth() - 1)), "dd/MM/yyyy");
    }
    return timeInt;
  };

  const getReceiptStatuses = (reportName) => {
    let receiptStat;

    if (reportName === "Revenue Collections" || reportName === "Transactions"){

      receiptStat = receiptStatuses.find((rcpt) => ( rcpt.description === "Issued" )).id;
      
    } else if (reportName === "Services Rendered"){

      receiptStat = receiptStatuses.find((rcpt) => ( rcpt.description === "Used")).id;
    }
    
    return receiptStat;
  };

  const handleRequestReport = (queryParams) => {
    props.onHandleSearchReport(queryParams);
  };

  const handleFormSubmit = (values) => {
    let reportName = allReferences.find((ref) => (ref.id === Number(values.reportName)));
    let fromToDates = values.interval ? calcFromToDates(values.interval) : values.interval;
    
    let newQueryParams = { 
      p_fromDate: fromToDates.description === "Specific" ? format(values.fromDate, "dd/MM/yyyy") : fromToDates.from, 
      p_toDate: fromToDates.description === "Specific" ? format(values.toDate, "dd/MM/yyyy") : fromToDates.to,
      p_timeInterval: fromToDates.description,   //check if this parameter is still in use
      p_provinceId: values.province,
      p_provAgencyId: provAgencyId,
      p_departmentId: agencyId, 
      p_reportType: reportName.description,
      p_receiptStat: getReceiptStatuses(reportName.description),
      p_serviceType: values.serviceType,
      p_serviceItem: values.serviceItem
    };
    
    handleRequestReport(newQueryParams);
  };

  return (
    <Card className="text-14">
      <Card.Header>
        <span className="row">
          <span className="col d-flex align-items-center"> 
            <h4> <ClipboardData size={26} /> {" "} Report Selection </h4> 
          </span>
          <span className="col">
            <span 
              className="p-0 m-0 d-flex justify-content-end"
            >
              { showSearch 
                ? <Button variant="light" onClick={() => {setShowSearch(false)}} > <CaretUpFill size={15} /> </Button>
                : <Button variant="light" onClick={() => {setShowSearch(true)}} > <CaretDownFill size={15} /> </Button>
              }
            </span>
          </span>
        </span>
      </Card.Header>
      <Collapse in={showSearch}>
        <Card.Body>
          <Formik
            initialValues={queryParamsInitialState}
            validationSchema={reportSearchFormSchema}
            onSubmit={(values, {setSubmitting}) => {
              setSubmitting(true);
              handleFormSubmit(values);            
              setSubmitting(false);
            }}
          >
          {({ values, errors, touched, handleBlur, handleChange, handleSubmit, isSubmitting, handleReset, setFieldValue, setFieldTouched }) => (
            <Form ref={searchFormRef} onSubmit={handleSubmit}>
            {/* begin: row 1 */}
            <Form.Row>
              <Col lg md={12} sm={12}>
                <Form.Group controlId="paramReportName">
                  <Form.Label>
                    <b>Report Type: <span className="text-danger">*</span></b>
                  </Form.Label>
                  <Form.Control
                    as="select"
                    name="reportName"
                    value={values.reportName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isInvalid={touched.reportName && errors.reportName}
                    className="form-select my-1 mr-sm-2"
                    custom
                  >
                    <option value="">-- Select --</option>
                    {reportTypes.map((ty, index) => (
                      <option key={index} value={ty.id}>
                        {ty.description}
                      </option>
                    ))}
                  </Form.Control>
                  <Form.Control.Feedback type="invalid">
                    {errors.reportName}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Form.Row>
            {/* end: row 1 */}
            <hr />
            {/* begin: row 2 */}
            <Form.Row>
              <Col lg md={12} sm={12}>
                <Form.Group controlId="paramProvince">
                  <Form.Label>
                    <b>Province:</b>
                  </Form.Label>
                  <Form.Control
                    as="select"
                    name="province"
                    value={values.province}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isInvalid={touched.province && errors.province}
                    className="form-select my-1 mr-sm-2"
                    custom
                  >
                    <option value="">-- Select --</option>
                    { provinces.map((prov, idx) => (
                      <option key={idx} value={prov.id}> 
                        {prov.name} 
                      </option>
                    ))}
                  </Form.Control>
                  <Form.Control.Feedback type="invalid">
                    {errors.province}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col lg md={12} sm={12}>
                <Form.Group controlId="paramServiceType">
                  <Form.Label>
                    <b>Service Type:</b>
                  </Form.Label>
                  <Form.Control
                    as="select"
                    name="serviceType"
                    value={values.serviceType}
                    onChange={(e) => {handleChange(e); filterServiceItems(e.target.value); setFieldValue("serviceItem", ""); }}
                    onBlur={handleBlur}
                    isInvalid={touched.serviceType && errors.serviceType}
                    className="form-select my-1 mr-sm-2"
                    custom
                  >
                    <option value="">-- Select --</option>

                    {serviceTypes.map((type, index) => (
                      <option key={index} value={type.id}>
                        {type.description}
                      </option>
                    ))}
                  </Form.Control>
                  <Form.Control.Feedback type="invalid">
                    {errors.serviceType}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col lg md={12} sm={12}>
                <Form.Group controlId="paramServiceItem">
                  <Form.Label>
                    <b>Service Item:</b>
                  </Form.Label>
                  <Form.Control
                    as="select"
                    name="serviceItem"
                    value={values.serviceItem}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isInvalid={touched.serviceItem && errors.serviceItem}
                    className="form-select my-1 mr-sm-2"
                    custom
                    disabled={ (values.serviceType === undefined || values.serviceType === "" || values.serviceType === null) }
                  >
                    <option value="">-- Select --</option>

                    { serviceItemList.map((item, idx) => (
                      <option value={item.id} key={idx}> {item.description} </option>
                    ))}
                  </Form.Control>
                  <Form.Control.Feedback type="invalid">
                    {errors.serviceItem}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Form.Row>
            {/* end: row 2 */}
            <hr />
            {/* begin: row 3 */}
            <Form.Row>
              <Col lg md={12} sm={12}>
                <Form.Group controlId="paramInterval">
                  <Form.Label>
                    <b>Time Interval:</b> <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    as="select"
                    name="interval"
                    value={values.interval}
                    onChange={(e) => { 
                      handleChange(e); 
                      setSelectedInterval(e.target.value);
                      setFieldValue("fromDate", "");
                      setFieldValue("toDate", ""); 
                    }}
                    onBlur={handleBlur}
                    isInvalid={touched.interval && errors.interval}
                    className="form-select my-1 mr-sm-2"
                    custom
                  >
                    <option value="">-- Select --</option>

                    { timeInterval.map((int, idx) => (
                      <option value={int.id} key={idx}> {int.description} </option>
                    ))}
                  </Form.Control>
                  <Form.Control.Feedback type="invalid">
                    {errors.interval}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col lg md={12} sm={12}>
                <Form.Group controlId="paramFromDate">
                <Form.Label> <Calendar4Week size={15} /> {" "} From:</Form.Label>
                  <ReactDatePicker
                    autoComplete="off"
                    className={touched.fromDate && errors.fromDate ? "form-control border border-danger" : "form-control"}
                    name="fromDate"
                    dateFormat="dd-MMMM-yyyy"
                    dateFormatCalendar="MMMM yyyy"
                    placeholderText={formatPresentDate}
                    selected={values.fromDate}
                    value={values.fromDate}
                    onChange={ (dt) => {
                      setFieldTouched("fromDate", true, true);
                      let date = dt;
                      if(date === null || date === undefined){
                        date = "";
                      }
                      let changes = { target: { name: "fromDate", value: date } };
                      handleChange(changes);  
                    }}
                    onBlur={handleBlur}
                    showMonthYearDropdown
                    scrollableMonthYearDropdown
                    minDate={new Date("06/01/2021")}
                    maxDate={presentDate}
                    todayButton="Today"
                    disabled={(customIntervalId !== Number(selectedInterval))}
                  />
                  {touched.fromDate && errors.fromDate ? <div className={styles.formErrorMsg}>{errors.fromDate}</div> : null}
                </Form.Group>
              </Col>
              <Col lg md={12} sm={12}>
                <Form.Group controlId="paramToDate">
                <Form.Label> <Calendar4Week size={15} /> {" "} To:</Form.Label>
                      <ReactDatePicker
                        autoComplete="off"
                        className={touched.toDate && errors.toDate ? "form-control border border-danger" : "form-control"}
                        name="toDate"
                        dateFormat="dd-MMMM-yyyy"
                        dateFormatCalendar="MMMM yyyy"
                        placeholderText={formatPresentDate}
                        selected={values.toDate}
                        value={values.toDate}
                        onChange={ (dt) => {
                          setFieldTouched("toDate", true, true);
                          let date = dt;
                          if(date === null || date === undefined){
                            date = "";
                          }
                          let changes = { target: { name: "toDate", value: date } };
                          handleChange(changes);  
                        }}
                        onBlur={handleBlur}
                        showMonthYearDropdown
                        scrollableMonthYearDropdown
                        minDate={new Date("06/01/2021")}
                        maxDate={presentDate}
                        todayButton="Today"
                        disabled={(customIntervalId !== Number(selectedInterval))}
                      />
                      { touched.toDate && errors.toDate ? <div className={styles.formErrorMsg}> {errors.toDate} </div> : null }
                </Form.Group>
              </Col>
            </Form.Row>
            {/* end: row 3 */}
            <Button type="submit" variant="primary" disabled={isSubmitting}>
              <Files size={15} /> Generate Report
            </Button>{" "}
            <Button onClick={() => { handleSearchReportReset(); handleReset(); }} variant="secondary">
              Reset
            </Button>
          </Form>
          )}
          </Formik>
        </Card.Body>
      </Collapse>
    </Card>
  );
}
